export default "__VITE_ASSET__BldrYsCO__";